// services/insights/competitive/utils/metrics.js
export class MetricsUtils {
    static calculateAverage(numbers) {
        if (!numbers.length) return 0;
        return numbers.reduce((sum, n) => sum + n, 0) / numbers.length;
    }

    static calculateMedian(numbers) {
        if (!numbers.length) return 0;
        const sorted = [...numbers].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
    }

    static calculatePercentChange(oldValue, newValue) {
        if (!oldValue) return 0;
        return ((newValue - oldValue) / oldValue) * 100;
    }

    static calculateGrowthRate(values, periods) {
        if (values.length < 2) return 0;
        const first = values[0];
        const last = values[values.length - 1];
        const timeDiff = periods || values.length - 1;
        return Math.pow(last / first, 1 / timeDiff) - 1;
    }

    static calculateMarketShare(value, total) {
        if (!total) return 0;
        return (value / total) * 100;
    }

    static normalizeDistribution(distribution) {
        const total = Object.values(distribution).reduce((sum, n) => sum + n, 0);
        if (!total) return {};
        return Object.entries(distribution).reduce((acc, [key, value]) => {
            acc[key] = (value / total) * 100;
            return acc;
        }, {});
    }
}